import { render, staticRenderFns } from "./benefits-slider.vue?vue&type=template&id=2e8c6dfc&"
import script from "./benefits-slider.vue?vue&type=script&lang=js&"
export * from "./benefits-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports